import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { BackButton, Loader, Toast } from "@egovernments/digit-ui-react-components";
import { Card } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import getApplicationData from "./getLTPData";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import ReactToPrint from "react-to-print";
import { registration } from "@egovernments/digit-ui-module-core/src/redux/actions";
import {
  MainWrapper,
  PortalWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  SideWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import Sidebar from "../../components/Sidebar";
import HeaderContent from "../../components/Header";
import FormStrip from "../../components/FormStrip";
import ButtonWrapper from "../../components/Button";
import SubStep1 from "./Step1/SubStep1";
import SubStep2 from "./Step1/SubStep2";
import SubStep3 from "./Step1/SubStep3";
import SubStep4 from "./Step1/SubStep4";
import SubStep5 from "./Step1/SubStep5";
import Step2 from "./Step2";
import { citizenBaseUrl, LTPSidebarlabels } from "../../components/data";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import SearchSummary from "./Summary/SearchSummary";
import get from "@egovernments/digit-ui-libraries/src/hooks/obps/useFormSubmitValidation";
import { useLocation } from "react-router-dom";
import AllRemarksList from "../../../../../../../templates/Forms/AllRemarks";

const LTPRegistration = () => {
  const dispatch = useDispatch();
  const { initRegistrationDocs, resetRegistrationDocs } = bindActionCreators(registration, dispatch);
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("REGISTRATION_CURRENT_TAB") || 0);
  const [subActiveTab, setSubActiveTab] = useState(Digit?.SessionStorage.get("REGISTRATION_CURRENT_SUBTAB") || 0);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const isUdFlow = applicationFlow === "DA";
  const stateCode = Digit.ULBService.getStateId() || "up";
  const location = useLocation();
  const isReapply = location?.state?.reapply; // 'reapply'
  //const isReapply = false;
  const tenantId = stateCode;
  const { applicationData, isAppDataLoading } = getApplicationData(id);
  const Modal = useModal();
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);

  const componentRef = useRef();
  const { data: { BPA: { Organizations: departmentList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "Organizations",
  ]);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("LTP_REGISTRATION", applicationData);
  const validationRules = [
    {
      path: "tradeLicenseDetail.owners.0.aadhaarNumber",
      errorMessage: "Please fill all the mandatory details in Applicant details tab.",
      condition: (value) => !value,
    },
    {
      path: "tradeLicenseDetail.owners.0.emailId",
      errorMessage: "Please fill all the mandatory details in contact information tab.",
      condition: (value) => !value,
    },
    {
      path: "authorityName",
      errorMessage: "Please fill all the mandatory details in registration detail tab.",
      condition: (value) => !value,
    },
    {
      path: "tradeLicenseDetail.applicationDocuments.0.fileStoreId",
      errorMessage: "Please upload all the mandatory documents in document tab.",
      condition: (value) => !value,
    },
  ];
  const daList = departmentList?.filter((item) => item.Type === "DA");
  const avpList = departmentList?.filter((item) => item.Type === "AVP")?.filter((item) => item.ShortName === "UPAVP");

  function filterDepartmentsList(completeList) {
    const officeNames = completeList?.map((office) => ({ value: office.Name, label: office.Name }));
    return officeNames;
  }
  const officesList = filterDepartmentsList(daList);
  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.tradeLicenseDetail?.applicationDocuments?.length > 0) {
        initRegistrationDocs(applicationData?.tradeLicenseDetail?.applicationDocuments);
      }
    }
  }, [id, applicationData]);
  const useFormSubmitValidation = (validationRules, payload) => {
    console.log("loggingPayload", payload, validationRules);

    const validate = () => {
      let formIsValid = true;

      // Iterate through validation rules and check conditions
      validationRules.forEach((rule) => {
        const { path, errorMessage, condition = (value) => !value } = rule;
        const value = get(payload, path);
        console.log("valueFromValidation", value, path);

        if (condition(value)) {
          Modal("Validation Error", errorMessage, "error");
          formIsValid = false;
          return; // You can't break out of forEach directly, so return early from the function
        }
      });
      return formIsValid;
    };
    const isValid = validate();
    return isValid;
  };
  const closeToast = () => {
    setShowToast(null);
  };

  const onSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams(data);
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "Registration");

  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: params?.applicationNumber,
    moduleCode: "BPAREG",
    config: {
      enabled: activeTab === 2 && !!params?.applicationNumber,
    },
  });

  const tradeType = params?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType;
  const isRevert = params?.status === "SENDBACK_TO_CITIZEN";
  const subTabLabels = [
    { label: "Applicant Type" },
    { label: "Applicant Details" },
    { label: "Contact Information" },
    { label: "Registration Details" },
    { label: "Document Details" },
  ];
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = [{ ...params, ...formData }];
      if ((tradeType === "ARCHITECT.CLASSA" && activeTab === 1) || isRevert) {
        data[0].action = "FORWARD_TO_DEPARTMENT";
      } else if (tradeType !== "ARCHITECT.CLASSA" && activeTab === 1) {
        data[0].action = "MAKE_PAYMENT";
      } else if (activeTab === 0) {
        data[0].action = "UPLOAD_DOC";
      }
      const isValid = useFormSubmitValidation(validationRules, data[0]);
      if (!isValid) {
        return;
      }
      try {
        updateApiCall.mutate(
          { Licenses: data },
          {
            onSuccess: (result) => {
              if (result?.Licenses?.length > 0) {
                onSelect("", result.Licenses[0]);
                // Modal(
                //     "Application updated.",
                //     `Application Updated Successfully!`,
                //     "success"
                // );
                // setShowToast({
                //     key: "true",
                //     error: false,
                //     message: (
                //         `Application Updated Successfully!`
                //     )
                // });
                // setActiveTab(nextTabNo);
                // Digit?.SessionStorage.set("REGISTRATION_CURRENT_TAB", nextTabNo);

                if (activeTab === 1) {
                  if (tradeType === "ARCHITECT.CLASSA" || isRevert) {
                    Modal(
                      "Application Submitted",
                      `Your Application ${result?.Licenses?.[0]?.applicationNumber} has been sent to the department for further Approval`,
                      "success"
                    );
                    clearParams();
                    setTimeout(() => {
                      resetRegistrationDocs();
                    }, 0);
                    setTimeout(() => {
                      Digit?.SessionStorage.del("REGISTRATION_CURRENT_TAB");
                      Digit?.SessionStorage.del("PROF_REGISTRATION");
                    }, 2000);
                    history.push(`${citizenBaseUrl}/obps/formProfessionalApplications`);
                  } else {
                    setShowToast({
                      key: "true",
                      error: false,
                      message: `Application Updated Successfully! Redirecting to the payment page...`,
                    });
                    history.push(
                      `${citizenBaseUrl}/payment/collect/${params?.businessService}/${params?.applicationNumber}/${tenantId}/tenantId=${tenantId}`
                    );
                  }
                }
              }
            },
            onError: () => {
              setShowToast({ error: true, message: `Something went wrong, please try again!` });
            },
          }
        );
      } catch (error) {
        Modal("Update Error.", `Something went wrong!!`, "error");
      }
    } else {
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("REGISTRATION_CURRENT_TAB", nextTabNo);
    }
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = [{ ...params, ...formData }];
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNumber" in params)) {
        if (isReapply) {
          data[0].applicationType = "RENEWAL";
          delete data[0].applicationNumber;
          delete data[0].id;
          data[0].workflow = {};
          data[0].workflow.action = "INITIATE";
          data[0].action = "INITIATE";
          data[0].validFrom = Date.now();
          data[0].validTo = Date.now();
        }
        Digit.OBPSService.BPAREGCreate({ Licenses: data }, tenantId)
          .then((result) => {
            if (result?.Licenses?.length > 0) {
              onSelect("", { ...formData, ...result.Licenses[0] }, "", true);
              // Modal(
              //     "Application created.",
              //     `Application Created Successfully!`,
              //     "success"
              // );
              setShowToast({
                key: "true",
                error: false,
                message: `Application Created Successfully!`,
              });

              setSubActiveTab(nextSubTab);
              Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((error) => {
            console.error("API Error Details:", {
              message: error.message, // "Network Error" or HTTP status text
              response: error.response?.data, // API error body (if available)
              status: error.response?.status, // HTTP status code (e.g., 400)
            });
            Modal("Create Error", error.response?.data?.Errors?.[0]?.message || "Something went wrong!!", "error");
          });
      } else {
        try {
          data[0].action = "UPLOAD_DOC";
          updateApiCall.mutate(
            { Licenses: data },
            {
              onSuccess: (result) => {
                if (result?.Licenses?.length > 0) {
                  onSelect("", result.Licenses[0]);
                  // Modal(
                  //     "Application updated.",
                  //     `Application Updated Successfully!`,
                  //     "success"
                  // );
                  setShowToast({
                    key: "true",
                    error: false,
                    message: `Data has been saved successfully!`,
                  });
                  if (nextSubTab === 5) {
                    setActiveTab(1);
                    Digit?.SessionStorage.set("REGISTRATION_CURRENT_TAB", 1);
                  } else {
                    setSubActiveTab(nextSubTab);
                    Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
                  }
                }
              },
              onError: (error) => {
                Modal("Update Error", error || "Something went wrong!", "error");
              },
            }
          );
        } catch (error) {
          Modal("Update Error", error || error?.response?.data?.Errors?.[0]?.message || "Something went wrong!!", "error");
        }
      }
    } else {
      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
    }
  };

  if (isAppDataLoading || (id && !applicationData)) {
    return <Loader />;
  }
  if (id) {
    if (!params?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType) {
      return <Loader />;
    }
  }
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return <SubStep1 formData={params} handleSubTabChange={handleSubTabChange} isReapply={isReapply} />;
        case 1:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isReapply={isReapply} />;
        case 2:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isReapply={isReapply} />;
        case 3:
          return (
            <SubStep4
              formData={params}
              handleSubTabChange={handleSubTabChange}
              setShowToast={setShowToast}
              showToast={showToast}
              isReapply={isReapply}
              officesList={officesList}
            />
          );
        case 4:
          return (
            <SubStep5
              formData={params}
              handleTabChange={handleTabChange}
              handleSubTabChange={handleSubTabChange}
              tradeType={tradeType}
              isReapply={isReapply}
              initRegistrationDocs={initRegistrationDocs}
            />
          );
        default:
          return null;
      }
    }
    // else if (activeTab === 1 && (tradeType !== 'ARCHITECT.CLASSA')) {
    //     return <Step2 formData={params} handleTabChange={handleTabChange} />;
    // }
    else if (activeTab === 1 && params?.applicationNumber) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary id={params?.applicationNumber} ref={componentRef} isEmployee={false} setDeclarationChecked={setDeclarationChecked} />
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={tradeType === "ARCHITECT.CLASSA" ? "Submit" : isRevert ? "Forward to Department" : "Make Payment"}
                type="submit"
                sx={{ backgroundColor: "#157CB3", width: "150px", letterSpacing: "normal" }}
                onClick={() => handleTabChange(2, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 2 && params?.applicationNumber) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} formData={params} />
        </React.Fragment>
      );
    }
  };

  return (
    <MainWrapper>
      <BackButton />
      <FormStrip formName={t("FASTPAS.GLOBAL.TPR.TEXT")} />
      <PrimaryTabsWrapper className="technical-profession-section">
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Applicant Information" />
          {/* <PrimaryTab label="Fee Details" /> */}
          <PrimaryTab label="Summary" />
          <PrimaryTab label="All Remarks" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={subActiveTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default LTPRegistration;
